/**
 *     wasm = WASM('JB1')   ; Calls wasm and initializes the game
 *     hand like: ["c103", "c110", "c008", "c206", "c113"]
 *
 *
 **/

import Ev from './Ev'
import HandValuation from './HandValuation'

function WASM(_game){

  var game = _game;
  var _status;
  const NUMBER = 'Number';
  const STRING = 'string';

  function callC(cFunc, returnType, argTypes, args){
    try {
      return Module.ccall(cFunc, returnType, argTypes, args)
    } catch (e){
      debug.error(e);
      debug.error("Deal with the error");
      return 0
    }
  }

  function getGameStoredEV(){ return callC('getGameStoredEV', NUMBER, [STRING], [game]) };
  function gameSetup()      { return callC('gameSetup',       NUMBER, [STRING], [game]) };
  function computeGameEV()  { return callC('computeGameEV',   NUMBER, [STRING], [game]) };
  function freeMemory()     { return callC('freeMemory', null, null, null) };

  function argTypes(hand){ return hand.map(c => STRING) }

  //function callGetEvaluateHand(hand){  return callC('evaluateHand', NUMBER, argTypes(hand), hand)};  // old
  function callGetEVs(hand){return callC('getEVs',      STRING, argTypes(hand), hand)};
  function callGetResult(hand){ return callC('getResult',   STRING, argTypes(hand), hand)};

  function getEVs(hand){
    debug.log('getEvs hand', hand)
    const wasmResult = callGetEVs(hand);
    const rows =  wasmResult.split("_").map( r => r.split("$"));
    debug.log('getEvs result',wasmResult);

    const evs = rows.map(row => new Ev(row));
    evs.reduce(evRanker,evs[0])
    return evs
  }

  const evRanker = function(accumulator, currentValue, index, arr){
    var rank
    var tie
    if (index==0){
      rank = 1;
      tie = false;
    } else {
      if (currentValue.ev < accumulator.ev) {
        //  rank  = accumulator.rank_without_ties + 1;
          rank  = index + 1;
          tie = false;
        }
      else {
        rank  = accumulator.rank_without_ties ;
        tie = true;
      }
    }
    currentValue.rank_without_ties = rank;
    currentValue.tie = tie
    currentValue.index = index
    arr[index] = currentValue;
    return currentValue;
  }

  function getResult(hand){
    const wasmResult = callGetResult(hand);
    return new HandValuation(wasmResult)
  }

  _status = gameSetup();

  function status(){
    return _status;
  }

  return Object.freeze({
      game,
      status,
      getResult,
      getEVs,
      freeMemory,
      getGameStoredEV,
      evRanker
  });
}

window.WASM = WASM
